import type { ModelAssignFormProps } from "./model-assign-form.type";

import { Form } from "antd";
import { useTranslation } from "react-i18next";

import SidePanelFormFooter from "@/modules/side-panel-form-footer";
import UsersSelect from "@/modules/users/users-select";

import { useModelAssignForm } from "./model-assign-form.hook";

const FORM_ID = "model-assign-form";

export const ModelAssignForm = (props: ModelAssignFormProps) => {
  const { t } = useTranslation();
  const {
    form,
    initialValues,
    loading,
    onSubmit,
    validation,
    validationErrors,
  } = useModelAssignForm(props);

  return (
    <Form
      form={form}
      id={FORM_ID}
      initialValues={initialValues}
      onFinish={onSubmit}
      layout="vertical"
      role="form"
    >
      <UsersSelect
        label={t("global:assignForm.users.label")}
        placeholder={t("global:assignForm.users.placeholder")}
        {...validation("users")}
      />
      {validationErrors().others && <Form.Item {...validation("others")} />}
      <SidePanelFormFooter
        submitText={t("global:action.assign")}
        submitProps={{ loading, form: FORM_ID }}
        position="follow-content"
      />
    </Form>
  );
};
